<ng-container *ngIf="{ darkMode: darkMode$ | async } as ui">
  <div *ngIf="jsonData">
    <div class="json-label" [ngClass]="{'text-light': ui.darkMode}">Parameters</div>
    <div class="border json-viewer rounded mt-2 p-4" [ngClass]="{'border-dark-700': ui.darkMode}">
      <ngx-json-viewer [ngClass]="{'darkMode': ui.darkMode}" [json]="jsonData" [expanded]="false"></ngx-json-viewer>
    </div>
  </div>
</ng-container>